export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_17.307dd804.jpg";